import * as React from "react";
import {useEffect} from "react";
import Router from "./Router";
import {FluentProvider, Theme, webLightTheme} from "@fluentui/react-components";
import {isDev} from "../util";
import Banner from "./components/Banner";
import { trixxoDarkTheme, trixxoLightTheme } from "./theme";

export default function App() {
    const [theme, setTheme] = React.useState<Theme>(getFluentTheme(Office.context.officeTheme));

    // listen to theme changes in outlook
    useEffect(() => {
        Office.context.mailbox.addHandlerAsync(
            Office.EventType.OfficeThemeChanged,
            (args: Office.OfficeThemeChangedEventArgs) => setTheme(getFluentTheme(args.officeTheme))
        );

        return () => Office.context.mailbox.removeHandlerAsync(Office.EventType.OfficeThemeChanged);
    }, []);

    return (
        <FluentProvider theme={theme}>
            <div style={{height: "100vh", display: "flex", flexDirection: "column", overflow: "hidden"}}>
                {isDev && <Banner message={"Running in dev mode"} variant={'warning'}/>}
                <Router/>
            </div>
        </FluentProvider>
    );
};

function getFluentTheme(officeTheme: Office.OfficeTheme): Theme {
    // NOTE: officeTheme.isDarkTheme doesn't work in outlook
    if (!officeTheme) return webLightTheme;

    const bg = officeTheme.bodyBackgroundColor;
    const hex = bg.replace('#', '');

    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

    return luminance < 0.5 ? trixxoDarkTheme : trixxoLightTheme;
}